<template>
  <div id="user-area" class="level">
    <div>
      <ul v-click-outside="hide">
        <li class="ham-tab-ico">
          <a><i class="fa" :class="show?'fa-close':'fa-bars'" @click="show?hide():show=true"/></a>
        </li>
        <label></label>
        <li v-if="tab.condition? tab.condition.call() : true"  v-for="(tab, index) in this.getTabs()" :key="index" :class="($route.name == tab.routerName ? 'active-tab ':'non-active-tab ') + (show?'':'hide-tabs')"
        :style="tab.router == 'bi' && $route.name == 'vforwarding' ? 'display:none' : ''">
          <a :href="'/' + tab.router" >
            <icon icoClass='tab-ico' :selected='tab.ico'/>
            <span>{{tab.name}}</span>
          </a>
        </li>
        <li class="non-active-tab" :class="show?'':'hide-tabs'" style="position:relative">
          <a @click="showUserConfig=!showUserConfig" >
            <icon icoClass='tab-ico' selected='config'/>
            <span>{{ user }} Config</span>
          </a>
          <span id="buttons" class="config-menu" v-if="showUserConfig">
            <modal-confirm v-if="user" @confirm="changePassword" @close="cancelation">
              <div slot="title">Change password</div>
              <span slot="body">
                  <input type="password" placeholder="Old password" class="input modal-input" name="old_password" id="old_password"  v-model="old_password">
                  <input type="password" placeholder="New password" class="input modal-input" name="new_password1" id="new_password1"  v-model="new_password1">
                  <input type="password" placeholder="Repite new password" class="input modal-input" name="new_password2" id="new_password2"  v-model="new_password2">
              </span>
              <div slot="footer">
              </div>
              <div slot="trigger">
                <button class="button is-small is-primary">Change Pass</button>
              </div>
            </modal-confirm>
            <button v-if="isManager && this.canWrite() && !isConventional" class="button is-small is-primary" @click="hide(); $router.push('teams-config');">Edit Teams</button>
            <button v-if="this.canWrite() && !isConventional" class="button is-small is-primary" @click="hide(); $router.push('projects-config');">Edit Projects</button>
            <button v-if="this.canWrite() && !isConventional" class="button is-small is-primary" @click="hide(); $router.push('free-days-config');">Edit Free Days</button>
            <button class="button is-small is-primary" @click="hide(); $router.push('user-config');">Edit User</button>
            <button class="button is-small is-black" @click="logout();">Log Out</button>
          </span>
        </li>
      </ul>
    </div>
    <div v-if="hasConventional" style="display: flex;">
      <label for="" class="text-form" style="margin-right: .5em;" :class="{'is-selected-lime-ico' : !isConventional}"><icon icoClass="switch-ico" selected='container-ship' /></label>
      <div class="form-input switches">
        <label class="switch">
          <input type="checkbox" :checked="isConventional" @change="changeConventionalStatus()">
          <span class="slider round"  :class="{'slider-selected-no-conventional' : !isConventional}"></span>
        </label>
      </div>
      <label for="" class="text-form" style="margin-left: .5em; margin-right: 1em;" :class="{'is-selected-turq-ico' : isConventional}">
        <icon icoClass="switch-ico" selected='ship' /></label>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import ModalConfirm from '@/components/ModalConfirm'
import icon from './../svg/tabs'
export default {
  name: 'user-area',
  props: ['user', 'hasConventional'],
  data () {
    return {
      tabs: [
        {name: 'DashBoard', ico: 'dashboard', router: 'dashboard', routerName: 'dashboard'},
        {name: 'Shipments', ico: 'shipments', routerName: 'shipment-list', router: 'shipments'},
        {name: 'Tracking Requests', ico: 'tracking', routerName: 'tracking-request-list', router: 'tracking-requests'},
        {name: 'New Tracking Request', ico: 'add', router: 'add-tracking-request', routerName: 'tracking-request-add'},
        {name: 'Where Are They?', ico: 'where', router: 'map-locations', routerName: 'map-locations'}
      ],
      tabsConventional: [
        {name: 'Shipments', ico: 'shipments', routerName: 'shipment-conventional-list', router: 'conventional/shipments'},
        {name: 'Tracking Requests', ico: 'tracking', routerName: 'conventional-tracking-request-list', router: 'conventional/tracking-requests'},
        {name: 'New Tracking Request', ico: 'add', routerName: 'conventional-tracking-request-add', router: 'conventional/add-tracking-request'}
        // {name: 'Where Are They?', ico: 'where', router: 'map-locations', routerName: 'map-locations'}
      ],
      show: false,
      showUserConfig: false,
      old_password: '',
      new_password1: '',
      new_password2: ''
    }
  },
  computed: {
    ...mapState({
      isManager: state => state.isManager,
      isConventional: state => state.auth.isConventional
    }),
    ...mapGetters({hasPermission: 'hasPermission'}),
    test () {
      return this.$route.name
    }
  },
  components: {ModalConfirm, icon},
  methods: {
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push('/login')
      })
    },
    canWrite () {
      return this.hasPermission('canWrite')
    },
    getTabs () {
      if (!this.canWrite()) {
        if (this.isConventional) {
          return [
            {name: 'Shipments', ico: 'shipments', routerName: 'shipment-conventional-list', router: 'conventional/shipments'},
            {name: 'Tracking Requests', ico: 'tracking', routerName: 'conventional-tracking-request-list', router: 'conventional/tracking-requests'}
          ]
        } else {
          return [
            {name: 'DashBoard', ico: 'dashboard', router: 'dashboard', routerName: 'dashboard'},
            {name: 'Shipments', ico: 'shipments', routerName: 'shipment-list', router: 'shipments'},
            {name: 'Tracking Requests', ico: 'tracking', routerName: 'tracking-request-list', router: 'tracking-requests'},
            {name: 'Where Are They?', ico: 'where', router: 'map-locations', routerName: 'map-locations'}
          ]
        }
      }
      if (this.isConventional) {
        return this.tabsConventional
      } else {
        return this.tabs
      }
    },
    changePassword () {
      this.$store.dispatch('auth/changePassword', {
        old_password: this.old_password,
        new_password1: this.new_password1,
        new_password2: this.new_password2
      })
      this.clearFields()
      this.hide()
    },
    cancelation () {
      this.clearFields()
      this.hide()
    },
    clearFields () {
      this.old_password = ''
      this.new_password1 = ''
      this.new_password2 = ''
    },
    changeConventionalStatus () {
      this.$store.dispatch('auth/setConventionalStatus', !this.isConventional).then(() => {
        if (this.isConventional) {
          this.$router.push('/conventional/shipments')
        } else {
          this.$router.push('/dashboard')
        }
      })
    },
    hide () {
      this.show = false
      this.showUserConfig = false
    }
  },
  directives: {
    clickOutside: {
      bind (el, binding, vnode) {
        var event = function (event) {
          // eslint-disable-next-line
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', event)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

.modal-input{
  margin-top: 10px
}
.button{
  font-weight: bold;
}
#buttons{
  margin: 3px 0;
  display: block;
  position: absolute;
}
.config-menu {
  border: 2px black solid;
  border-radius: .5em;
  overflow: hidden;
  text-align: center;
  padding: 0 .1em;
  background: white;
  .button {
    width: 100%;
    border-radius: .5em;
    margin: .1em 0;
    box-sizing: border-box
  }
}

.slider-selected-no-conventional {
  background-color: $lime-text;
}
</style>





// WEBPACK FOOTER //
// src/components/UserArea.vue